// extracted by mini-css-extract-plugin
export default {"wrapper":"ScheduleInGoogleCalendar_wrapper__SaLUY","text":"ScheduleInGoogleCalendar_text__BPfcC"};